export { textInChip, textHasDiscount, textSuizaTucuman } from './texts';
